import { PersonAuthorizations } from './person';

export enum HistorianAuthorization {
  Search = '',
}

export const HistorianAuthorizationList = [PersonAuthorizations.HistoryPerson];
